
export const parseLabelUnit = (label) => {
  const match = /^(.*?)\s*\(([^()]+)\)\s*$/.exec(label)
  return match ? { label: match[1], unit: match[2] } : { label, unit: undefined }
}


export const headerLabel = (col) => (col.unit ? `${col.label} (${col.unit})` : col.label)
